export { ImageFrame } from './ImageFrame';
export { Img, Placeholder } from './ImageFrame.styles';
export type { ImageFrameProps } from './ImageFrame.types';
